import { c as _c } from "react/compiler-runtime";
import { CoverageApiProvider } from '@newfront-insurance/coverage-ui';
import type { PropsWithChildren, JSX } from 'react';
export function AccountsCoverageApiProvider(props) {
  const $ = _c(2);
  const {
    children
  } = props;
  let t0;
  if ($[0] !== children) {
    t0 = <CoverageApiProvider basePath="/api/coverage">{children}</CoverageApiProvider>;
    $[0] = children;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}